export default {
    to: "/dashboard/waas/onboarding",
    order: 3,
    icon: "mdi-clipboard-account",
    title: "Onboarding",
    disabled: false,
    value: 0,
    sublinks: [
        {
            to: "/dashboard/waas/onboarding/entity",
            order: 3,
            icon: "mdi-clipboard-check-outline",
            title: "Entity",
            disabled: false,
            value: 0,
        },
        {
            to: "/dashboard/waas/onboarding/beneficiary",
            order: 3,
            icon: "mdi-clipboard-file",
            title: "Beneficiary",
            disabled: false,
            value: 0,
        },
    ]
}
